import { MD5, enc } from 'crypto-js';

type TEncoding = Parameters<ReturnType<typeof MD5>['toString']>[0];
// eslint-disable-next-line import/prefer-default-export
export const md5Hash = (
  value: string,
  encoding: TEncoding = enc.Hex,
) => MD5(value).toString(encoding);
